import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const SSpan = styled.span`
  margin-right: 8px;
  font-size: 17px;
  border: 1px solid black;
  border-radius: 4px;
  padding: 2px 6px 2px 6px;
  position: relative;
  bottom: 3px;
  width: fit-content;
  height: 24px;
  font-weight: 700;
`;

export default function StockCode({ code, exchange }) {
  let displayCode = code.toUpperCase();

  if (!displayCode.includes(':') && exchange) {
    displayCode = `${exchange.toUpperCase()}:${displayCode}`;
  }

  return (
    <SSpan>{displayCode}</SSpan>
  );
}

StockCode.propTypes = {
  code: PropTypes.string.isRequired,
  exchange: PropTypes.string.isRequired,
};
